module.exports = __webpack_public_path__ + "static/media/betterflosspro-5.834b8f56.jpg";